import { Fragment } from "react"
import { Col, Row } from "reactstrap"
import FooterLeft from "./FooterLeft"
import BodyMidBottom from "../Body/TabBodyMid/BodyMidBottom"

const Footer = ({ data }) => {
  return (
    <Fragment>
      <Row>
        <Col lg="6" style={{ height: 'auto', paddingRight: '6px' }}>
          <FooterLeft data={data} />
        </Col>
        <Col lg="6" style={{ height: 'auto', paddingLeft: '6px' }}>
          <BodyMidBottom data={data?.dailySampleDensity} />
        </Col>
      </Row>
    </Fragment>
  )
}

export default Footer
